exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sound-needed-alert[data-v-64274ecf]{padding:10px;background-color:#243863;color:#fff;margin-bottom:15px}.sound-needed-alert .closebtn[data-v-64274ecf]{margin-left:15px;color:#fff;font-weight:700;float:right;font-size:22px;line-height:20px;cursor:pointer;transition:.3s}.sound-needed-alert .closebtn[data-v-64274ecf]:hover{color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-64274ecf&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App/protected/components/upload/Upload.vue
// module id = 590
// module chunks = 0